import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const MAX_TILE_COLUMNS = 6;
const mapToMaxValue = value => value && value > MAX_TILE_COLUMNS ? MAX_TILE_COLUMNS : value;

// Standard format with which to responsively set styles on

export const mobileFirstQueries = ['@media (min-width: 480px)', '@media (min-width: 768px)', '@media (min-width: 992px)', '@media (min-width: 1200px)'];
const MOBILE_FIRST_QUERIES_COUNT = mobileFirstQueries.length + 1;

/**
 * Parse responsive styles object
 *
 * Takes a ResponsiveStyleProp and a transformer and returns a
 * style object with mobile-first styles with the shape
 * transformer(value) that can be consumed by styled-components
 */
export const parseResponsiveStyleObject = (prop, transformer, defaults) => {
  let normalizedProp = [];
  // return defaults if the value is falsy or an array that starts with falsy value
  if (!prop || Array.isArray(prop) && !prop[0]) {
    console.error(`${prop} is not a valid responsive prop, default value is returned`);
    normalizedProp = defaults;
  } else {
    // map number to array and make sure values do not exceed their maximum
    normalizedProp = (Array.isArray(prop) ? prop : [prop]).map(mapToMaxValue).slice(0, MOBILE_FIRST_QUERIES_COUNT);
  }
  // return object built from array
  return normalizedProp.reduce((accumulator, current, index) => {
    if (!current) {
      return accumulator;
    }
    const newValue = index === 0 ? transformer(current) : {
      [mobileFirstQueries[index - 1]]: _objectSpread({}, transformer(current))
    };
    return _objectSpread(_objectSpread({}, accumulator), newValue);
  }, {});
};

/**
 * Parse responsive styles array
 *
 * Takes a ResponsiveStyleProp and converts it to a number array
 * for use with some plugins (e.g. slick slider)
 */
export const parseResponsiveStylesArray = (prop, defaults) => {
  // return defaults if the value is falsy or an array that starts with falsy value
  if (!prop || Array.isArray(prop) && !prop[0]) {
    console.error(`${prop} is not a valid responsive prop, default value is returned`);
    return defaults;
  }
  // map number to array
  if (!Array.isArray(prop)) {
    return Array.from(Array(MOBILE_FIRST_QUERIES_COUNT), () => prop);
  }
  // eliminate nulls and 0 by replacing them with most recent non-null value
  const propNoNull = prop.map((value, index) => {
    if (!value) {
      // get array of previous values
      // reverse to have values start with closest from current index
      const previousReversed = prop.slice(0, index).reverse();
      // apply non-null value closest from current
      return previousReversed.find(value => !!value);
    }
    return value;
  });
  // fill array to length of queries
  if (propNoNull.length < MOBILE_FIRST_QUERIES_COUNT) {
    const remaining = Array.from(Array(MOBILE_FIRST_QUERIES_COUNT - propNoNull.length), () => propNoNull[propNoNull.length - 1]);
    return [...propNoNull, ...remaining];
  }
  return propNoNull.map(mapToMaxValue).slice(0, MOBILE_FIRST_QUERIES_COUNT);
};